// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-rootwidget .modal-body {\n  overflow-x: hidden !important;\n}\n.widget-rootwidget .modal-header {\n  background: inherit !important;\n  box-shadow: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
